import { newClient } from '../axios-client-factory'


export const getApplySeatus = function(id) {
  return newClient().get('/guild/apply/guild/status')
}
export const guildSave = function(model) {
  return newClient().post('/guild/apply/guild/save',model)
}

export const getGuildAdminNickname = function(id) {
  return newClient().get('/guild/apply/guild/getAppNickName/'+id)
}

export const getGuildAdminNicknameV1 = function(id) {
  return newClient().get('/guild/apply/guild/userInfo/'+id)
}

export const getGuildAdminCheckUser = function (id) {
  return newClient().get('guild/apply/guild/checkUser/'+id)
}

export const checkMe = function() {
  return newClient().get('/guild/apply/guild/checkMe')
}



// WEBPACK FOOTER //
// ./src/api/apply/index.js